import { Option } from "./Form";

export const createOption = (
  label: string,
  sinonimos?: string[],
  nombre_comercial?: string,
  drogas?: string,
  tipo_accion?: string
): Option => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
  sinonimos,
  nombre_comercial,
  drogas,
  tipo_accion,
});

export const filterMedicamentos = (
  candidate: Option,
  inputValue: string
): boolean => {
  const searchValue = inputValue.toLowerCase();
  const { label, nombre_comercial, drogas, tipo_accion } = candidate;

  // Devuelve true si alguno de los campos incluye el valor de búsqueda
  return (
    (label?.toLowerCase().includes(searchValue) ?? false) ||
    (nombre_comercial?.toLowerCase().includes(searchValue) ?? false) ||
    (drogas?.toLowerCase().includes(searchValue) ?? false) ||
    (tipo_accion?.toLowerCase().includes(searchValue) ?? false)
  );
};

export const filterBySynonyms = (
  candidate: Option,
  inputValue: string
): boolean => {
  const searchValue = inputValue.toLowerCase();
  const { label, sinonimos = [] } = candidate;

  // Devuelve true si el label o alguno de los sinónimos incluye el valor de búsqueda
  return (
    label.toLowerCase().includes(searchValue) ||
    sinonimos.some((sinonimo) => sinonimo.toLowerCase().includes(searchValue))
  );
};

export function normalizeText(str: string): string {
  return str
    ? str
        .normalize("NFD") // separa acentos
        .replace(/[\u0300-\u036f]/g, "") // elimina diacríticos
        .toLowerCase()
    : "";
}
